import { render, staticRenderFns } from "./MobileAppFaq.vue?vue&type=template&id=6fdcf77c&scoped=true&"
import script from "./MobileAppFaq.vue?vue&type=script&lang=js&"
export * from "./MobileAppFaq.vue?vue&type=script&lang=js&"
import style0 from "./MobileAppFaq.vue?vue&type=style&index=0&id=6fdcf77c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdcf77c",
  null
  
)

export default component.exports